import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance31w1ky5wvnamo as Companion_getInstance } from '../../models/Theme.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CanvasDelegate$invalidate$lambda() {
  return Unit_instance;
}
var CanvasDelegateClass;
function CanvasDelegate() {
  if (CanvasDelegateClass === VOID) {
    class $ {
      static sd9() {
        var $this = createThis(this);
        var tmp = $this;
        tmp.zbh_1 = CanvasDelegate$invalidate$lambda;
        $this.abi_1 = Companion_getInstance().od1_1;
        return $this;
      }
      td9(width, height) {
      }
      ud9(context) {
      }
      nbi(id, x, y, width, height) {
        return false;
      }
      obi(id, x, y, width, height) {
        return false;
      }
      qbi(id, x, y, width, height) {
        return false;
      }
      pbi(id, x, y, width, height) {
        return false;
      }
      bbi(key) {
        return false;
      }
      cbi(key) {
        return false;
      }
      dbi(x, y, z) {
        return false;
      }
    }
    initMetadataForClass($, 'CanvasDelegate');
    CanvasDelegateClass = $;
  }
  return CanvasDelegateClass;
}
//region block: exports
export {
  CanvasDelegate as CanvasDelegate2sttw7eh6wg08,
};
//endregion

//# sourceMappingURL=Canvas.mjs.map
